import * as React from "react";

import PropTypes from "prop-types";
import cs from "classnames";

import { Image, Button } from "@lululemon/ui-library";

import { ErrorBoundary } from "@lululemon/mwa-logger";
import { productEdHandleError } from "@lululemon/ecom-common/src/util/product-education-logger";

import styles from "./cdp-hero-banner.module.scss";

const CDP_HERO_IMAGE_MAX_WIDTH = 1970;

const CDPHeroBanner = ({
  imageUrl,
  imageDescription,
  title,
  subTitle,
  callToAction,
  callToActionUrl,
  textColor,
  textPosition,
  ctaAnalyticsTrack,
}) => {
  const showImage = imageUrl && imageDescription;
  const showHeading = title || subTitle;
  const showCtaButton = callToActionUrl && callToAction;

  if (!showImage && !showHeading && !showCtaButton) return null;

  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(error, "CdpHeroBanner", "CDP Hero")
      }
    >
      <div data-testid="cdp-hero-banner" className={styles.cdpHeroBanner}>
        {showImage && (
          <Image
            className={styles.cdpHeroBannerImage}
            prefix="cdp-hero"
            maxWidth={CDP_HERO_IMAGE_MAX_WIDTH}
            lazy={false}
            src={imageUrl}
            alt={imageDescription}
          />
        )}
        {showHeading && (
          <div className={styles.cdpHeroBannerContent}>
            <h2
              className={cs(styles.cdpHeroBannerHeading, {
                [styles.cdpHeroBannerHeadingLight]: textColor === "light",
                [styles.cdpHeroBannerHeadingCenter]: textPosition === "center",
                [styles.cdpHeroBannerHeadingRight]: textPosition === "right",
              })}
            >
              {title}
              <span className={styles.cdpHeroBannerSubheading}>{subTitle}</span>
            </h2>
            {showCtaButton && (
              <Button
                className={cs(styles.cdpHeroBannerCtaButton, {
                  [styles.cdpHeroBannerCtaButtonDark]: textColor === "dark",
                  [styles.cdpHeroBannerCtaButtonCenter]:
                    textPosition === "center",
                  [styles.cdpHeroBannerCtaButtonRight]:
                    textPosition === "right",
                })}
                href={callToActionUrl}
                data-lulu-track={ctaAnalyticsTrack}
              >
                {callToAction}
              </Button>
            )}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

CDPHeroBanner.defaultProps = {
  imageUrl: "",
  imageDescription: "",
  title: "",
  subTitle: "",
  callToAction: "",
  callToActionUrl: "",
  textColor: "",
  textPosition: "left",
  ctaAnalyticsTrack: "",
};

CDPHeroBanner.propTypes = {
  imageUrl: PropTypes.string,
  imageDescription: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  callToAction: PropTypes.string,
  callToActionUrl: PropTypes.string,
  textColor: PropTypes.string,
  textPosition: PropTypes.string,
  ctaAnalyticsTrack: PropTypes.string,
};

export default CDPHeroBanner;
